export default __webpack_public_path__ + "assets/820f48fceea40321737aae5b7587756d.woff2";